module.exports = __webpack_public_path__ + "img/pr-5.2a9ef5f4.png";